import L from "leaflet";

// Keep the selected overlay in the layer picker, but only mount its tiles
// while visible. Opacity alone does not stop Leaflet requesting tiles.
function createOverlay(tileLayer) {
  const overlay = L.layerGroup();
  overlay.options.opacity = 0;
  overlay.setOpacity = (value) => {
    const opacity = Math.max(0, Math.min(1, Number(value) || 0));
    overlay.options.opacity = opacity;
    tileLayer.setOpacity(opacity);
    if (opacity > 0) {
      overlay.addLayer(tileLayer);
    } else {
      overlay.removeLayer(tileLayer);
    }
    return overlay;
  };
  return overlay;
}

export { createOverlay };
